class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector("form");
    if (facetForm)
      facetForm.addEventListener("input", this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
    if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll(".js-facet-remove").forEach((element) => {
      element.classList.toggle("disabled", disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById("ProductCount");
    const countContainerDesktop = document.getElementById(
      "ProductCountDesktop",
    );
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove("hidden"));
    document
      .getElementById("ProductGridContainer")
      .querySelector(".collection")
      .classList.add("loading");
    if (countContainer) {
      countContainer.classList.add("loading");
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add("loading");
    }

    sections.forEach((section) => {
      var url = "";
      if (window.location.pathname.includes("search")) {
        url = `${window.location.pathname}?${searchParams}`;
      } else {
        url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      }
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [
          ...FacetFiltersForm.filterData,
          { html, url },
        ];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html, event);
        // FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === "function")
          initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html, event);
    // FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === "function")
      initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html, event) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });

    var urlParams = new URLSearchParams(window.location.search);

    const activeFilters = [];
    const activeSorting = [];

    urlParams.forEach((value, key) => {
      if (key.startsWith("filter.")) {
        activeFilters.push(`${key}=${value}`);
      }
      if (key === "sort_by") {
        activeSorting.push(`${key}=${value}`);
      }
    });

    if (activeFilters.length > 0 || activeSorting.length > 0) {
      if (typeof window.initializeAjaxinateIfNoFilters === "function") {
        window.initializeAjaxinateIfNoFilters();
      }
      if (typeof window.moduloImages === "function") {
        window.moduloImages();
      }
      if (typeof window.destroyAjaxinate === "function") {
        window.destroyAjaxinate();
      }
      // Destroy Ajaxinate when filters are applied
      // if (typeof destroyAjaxinate === 'function') {
      // }
      if (typeof window.hydrateAllSlides === "function") {
        window.hydrateAllSlides();
      }
    } else {
      // Reinitialize Ajaxinate when returning to unfiltered view with slight delay
      setTimeout(() => {
        if (typeof window.initializeAjaxinateIfNoFilters === "function") {
          window.initializeAjaxinateIfNoFilters();
          window.moduloImages();
        }
        if (typeof window.hydrateAllSlides === "function") {
          window.hydrateAllSlides();
        }
      }, 100);
    }

    var sortBy = urlParams.get("sort_by");

    if (sortBy) {
      FacetFiltersForm.customSorting(sortBy);
    }

    // Run filtering after DOM injection; one immediate and one short-delay pass
    FacetFiltersForm.customFiltering();
    setTimeout(() => {
      try {
        FacetFiltersForm.customFiltering();
      } catch (e) {}
    }, 50);

    FacetFiltersForm.resetMiniaturesListeners();

    var productImagePicker = urlParams.get("image");
    if (productImagePicker) {
      FacetFiltersForm.slideToSwiperImageInner(productImagePicker);
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductCount").innerHTML;
    const container = document.getElementById("ProductCount");
    const containerDesktop = document.getElementById("ProductCountDesktop");
    container.innerHTML = count;
    container.classList.remove("loading");
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove("loading");
    }
    const loadingSpinners = document.querySelectorAll(
      ".facets-container .loading__spinner, facet-filters-form .loading__spinner",
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add("hidden"));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter",
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (
        !Array.from(facetDetailsElementsFromFetch).some(
          ({ id }) => currentElement.id === id,
        )
      ) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element),
    );
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(
      matchesId,
    );

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML =
          elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } =
            facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document
            .querySelector(`#${elementToRender.parentElement.id} .js-filter`)
            .before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    // After filters (chips/labels) update, re-run filtering to ensure label-based matches are available
    try {
      FacetFiltersForm.customFiltering();
    } catch (e) {}

    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter"),
        );
        FacetFiltersForm.renderMobileCounts(
          countsToRender,
          document.getElementById(closestJSFilterID),
        );

        const newFacetDetailsElement =
          document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains(
          "mobile-facets__details",
        )
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate =
          newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute("type") === "text";

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = [
      ".active-facets-mobile",
      ".active-facets-desktop",
    ];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML =
        activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [
      ".mobile-facets__open",
      ".mobile-facets__count",
      ".sorting",
    ];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML =
        html.querySelector(selector).innerHTML;
    });

    document
      .getElementById("FacetFiltersFormMobile")
      .closest("menu-drawer")
      .bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector(".facets__summary");
    const sourceSummary = source.querySelector(".facets__summary");

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector(".facets__header");
    const sourceHeaderElement = source.querySelector(".facets__header");

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector(".facets-wrap");
    const sourceWrapElement = source.querySelector(".facets-wrap");

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(
        target.querySelector("show-more-button .label-show-more.hidden"),
      );
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll(".facets__item.hidden")
          .forEach((hiddenItem) =>
            hiddenItem.classList.replace("hidden", "show-more-item"),
          );
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector(".mobile-facets__list");
    const sourceFacetsList = source.querySelector(".mobile-facets__list");

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.getElementById("product-grid").dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll(
      "facet-filters-form form",
    );
    const forms = [];

    sortFilterForms.forEach((form) => {
      forms.push(this.createSearchParams(form));
    });

    // add image param
    var urlParams = new URLSearchParams(window.location.search);
    var productImagePicker = urlParams.get("image");

    if (
      productImagePicker &&
      (productImagePicker == 0 || productImagePicker == 1)
    ) {
      forms.push("image=" + productImagePicker);
    }

    this.onSubmitForm(forms.join("&"), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    var url =
      event.currentTarget.href.indexOf("?") == -1
        ? ""
        : event.currentTarget.href.slice(
            event.currentTarget.href.indexOf("?") + 1,
          );

    var urlParams = new URLSearchParams(window.location.search);
    var productImagePicker = urlParams.get("image");

    if (productImagePicker) {
      if (productImagePicker == 0) {
        url = url + "&image=0";
      } else if (productImagePicker == 1) {
        url = url + "&image=1";
      }
    }

    FacetFiltersForm.renderPage(url);
  }

  static customSorting(sortOption) {
    if (sortOption == "weight-ascending" || sortOption == "weight-descending") {
      var products = document.querySelectorAll(".product_item");
      var productArray = Array.from(products);

      productArray.sort(function (a, b) {
        var weightA = parseFloat(a.getAttribute("data-weight"));
        var weightB = parseFloat(b.getAttribute("data-weight"));

        if (sortOption === "weight-ascending") {
          return weightA - weightB;
        } else if (sortOption === "weight-descending") {
          return weightB - weightA;
        }
      });

      var productContainer = document.getElementById("product-grid");
      productArray.forEach(function (product) {
        productContainer.appendChild(product);
      });
    }

    // 11-11-24 comment if to show all variants of best selling products
    // if (sortOption == "best-selling") {
    //   var products = document.querySelectorAll('.product_item');
    //   var productArray = Array.from(products);

    //   var uniqueHandles = new Set();

    //   var filteredProducts = productArray.filter(function (product) {
    //     var handle = product.getAttribute('data-handle');

    //     if (!uniqueHandles.has(handle)) {
    //       uniqueHandles.add(handle);
    //       return true;
    //     }
    //     return false;
    //   });

    //   var productContainer = document.getElementById('product-grid');

    //   productContainer.innerHTML = '';

    //   filteredProducts.forEach(function (product) {
    //     productContainer.appendChild(product);
    //   });
    // }
  }

  static customFiltering(isRetry = false) {
    // COLOR AND SIZE FILTERING

    var productContainer = document.getElementById("product-grid");
    var products = document.querySelectorAll(".product_item");
    var productArray = Array.from(products);
    var filteredProducts = [];

    var colorFilterInputs = document.querySelectorAll(
      'input[id*="option.color"]',
    );
    var colorFilterApplied = false;

    var sizeFilterInputs = document.querySelectorAll(
      'input[id*="option.size"], input[name*="option.size"]',
    );
    var sizeFilterApplied = false;

    var badgeFilterInputs = document.querySelectorAll(
      'input[id*="custom.badge"]',
    );
    var badgeFilterApplied = false;

    const normalizeColor = (value) =>
      (value || "").toString().trim().toLowerCase();

    const urlParamsCurrent = new URLSearchParams(window.location.search);

    // COLOR FILTER
    if (colorFilterInputs.length > 0) {
      const selectedColors = [];
      const seen = new Set();

      const addSelection = (value, label) => {
        const normalizedLabel = normalizeColor(label || value);
        const key = `${value}__${normalizedLabel}`;
        if (seen.has(key)) return;
        seen.add(key);
        selectedColors.push({
          value,
          label: label || value,
          normalized: normalizedLabel,
        });
      };

      // Collect from checked inputs
      colorFilterInputs.forEach((input) => {
        if (input.checked) {
          addSelection(input.value, input.dataset.label);
        }
      });

      // Also collect from URL params (covers cases where inputs are not marked checked)
      const urlColorParams = urlParamsCurrent.getAll("filter.v.option.color");
      urlColorParams.forEach((val) => {
        const matchingInput = Array.from(colorFilterInputs).find(
          (inp) => inp.value === val,
        );
        const labelFromInput = matchingInput
          ? matchingInput.dataset.label || matchingInput.value
          : val;
        addSelection(val, labelFromInput);
      });

      if (selectedColors.length > 0) {
        const allLookLikeGids = selectedColors.every(
          (c) =>
            c.normalized.includes("filtersettinggroup") ||
            c.normalized.startsWith("gid://"),
        );

        if (allLookLikeGids) {
          const activeFacetLabels = Array.from(
            document.querySelectorAll(
              ".active-facets__button-inner, .active-facets__button, .active-facets__button--light",
            ),
          )
            .map((el) => el.textContent || "")
            .map((txt) => {
              const parts = txt.split(":");
              return parts.length > 1 ? parts.slice(1).join(":") : txt;
            })
            .map((txt) => txt.replace(/Remove filter/i, ""))
            .map((txt) => normalizeColor(txt))
            .filter(Boolean);

          if (
            activeFacetLabels.length === 0 &&
            !isRetry &&
            (window.__facetsColorRetry || 0) < 3
          ) {
            window.__facetsColorRetry = (window.__facetsColorRetry || 0) + 1;
            setTimeout(() => FacetFiltersForm.customFiltering(true), 60);
            return;
          }

          activeFacetLabels.forEach((normLabel) => {
            if (selectedColors.some((c) => c.normalized === normLabel)) return;
            selectedColors.push({
              value: normLabel,
              label: normLabel,
              normalized: normLabel,
            });
          });
        }

        window.__facetsColorRetry = 0;

        colorFilterApplied = true;

        productArray.forEach(function (product) {
          var hasAvailableSize = false;
          var sizeSelectors = product.querySelectorAll(
            'form[action="/cart/add"]',
          );

          let matchesColor = false;
          selectedColors.forEach((selColor) => {
            const productVariantColor =
              product.getAttribute("data-variant-color");
            const productVariantNormalized =
              normalizeColor(productVariantColor);
            const productColorValue = product.getAttribute("data-color-filter");
            const productColorNormalized = normalizeColor(productColorValue);
            var normalizedSelectedColor = selColor.normalized;

            if (
              productVariantNormalized === normalizedSelectedColor ||
              productColorNormalized === normalizedSelectedColor
            ) {
              matchesColor = true;
            }
          });

          if (!matchesColor) {
            product.remove();
            return;
          }

          // Only size prune on matches
          sizeSelectors.forEach((selector) => {
            if (selector.classList.contains("disabled")) {
              selector.remove();
            } else {
              hasAvailableSize = true;
            }
          });

          if (hasAvailableSize && !filteredProducts.includes(product)) {
            filteredProducts.push(product);
          } else if (!hasAvailableSize) {
            product.remove();
          }
        });
      }
    }

    // SIZE FILTER
    if (sizeFilterInputs.length > 0) {
      const normalizeSize = (value) => {
        const normalized = (value || "")
          .toString()
          .trim()
          .toLowerCase()
          .replace(/\./g, "")
          .replace(/\s+/g, " ");

        const compact = normalized.replace(/[\s_-]+/g, "");

        if (compact === "s") return "s";
        if (compact === "m") return "m";
        if (compact === "l") return "l";
        if (compact === "xl") return "xl";
        if (compact === "xxl") return "xxl";
        if (compact === "small") return "s";
        if (compact === "medium") return "m";
        if (compact === "large") return "l";
        if (compact === "xlarge" || compact === "extralarge") return "xl";
        if (
          compact === "xxlarge" ||
          compact === "2xlarge" ||
          compact === "extraxtralarge" ||
          compact === "extraextralarge"
        ) {
          return "xxl";
        }

        return normalized;
      };
      const getSizeInputLabel = (input) => {
        if (!input) return "";
        if (input.dataset && input.dataset.label) return input.dataset.label;
        const closestLabel = input.closest("label");
        if (!closestLabel) return "";
        const labelNode = closestLabel.querySelector(".facet-checkbox__text-label");
        return labelNode ? labelNode.textContent : "";
      };

      const selectedSizes = [];
      const seenSizes = new Set();

      const addSizeSelection = (value, label) => {
        const normalizedLabel = normalizeSize(label || value);
        const key = `${value}__${normalizedLabel}`;
        if (!normalizedLabel || seenSizes.has(key)) return;
        seenSizes.add(key);
        selectedSizes.push({
          value,
          label: label || value,
          normalized: normalizedLabel,
        });
      };

      const getActiveSizeFacetLabels = () =>
        Array.from(
          document.querySelectorAll(
            ".active-facets__button-inner, .active-facets__button, .active-facets__button--light",
          ),
        )
          .map((el) => el.textContent || "")
          .map((txt) => txt.replace(/Remove filter/i, "").trim())
          .map((txt) => {
            const parts = txt.split(":");
            if (parts.length < 2) return "";
            const facetName = normalizeSize(parts[0]);
            if (!facetName.includes("size")) return "";
            return parts.slice(1).join(":");
          })
          .map((txt) => normalizeSize(txt))
          .filter(Boolean);

      // Collect from checked inputs
      sizeFilterInputs.forEach((input) => {
        if (input.checked) {
          addSizeSelection(input.value, getSizeInputLabel(input));
        }
      });

      // Also collect from URL params (covers cases where inputs are not marked checked)
      const urlSizeParams = urlParamsCurrent.getAll("filter.v.option.size");
      urlSizeParams.forEach((val) => {
        const matchingInputs = Array.from(sizeFilterInputs).filter(
          (inp) => inp.value === val,
        );
        const matchingInput =
          matchingInputs.find((inp) => Boolean(getSizeInputLabel(inp))) ||
          matchingInputs[0];
        const labelFromInput = matchingInput
          ? getSizeInputLabel(matchingInput) || matchingInput.value
          : val;
        addSizeSelection(val, labelFromInput);
      });

      getActiveSizeFacetLabels().forEach((normLabel) => {
        if (selectedSizes.some((s) => s.normalized === normLabel)) return;
        selectedSizes.push({
          value: normLabel,
          label: normLabel,
          normalized: normLabel,
        });
      });

      const allLookLikeSizeGids =
        selectedSizes.length > 0 &&
        selectedSizes.every(
          (s) =>
            s.normalized.includes("filtersettinggroup") ||
            s.normalized.startsWith("gid://"),
        );

      if (allLookLikeSizeGids) {
        const activeSizeFacetLabels = getActiveSizeFacetLabels();

        activeSizeFacetLabels.forEach((normLabel) => {
          if (selectedSizes.some((s) => s.normalized === normLabel)) return;
          selectedSizes.push({
            value: normLabel,
            label: normLabel,
            normalized: normLabel,
          });
        });
      }

      if (allLookLikeSizeGids && selectedSizes.length > 0) {
        const hasHumanReadableSize = selectedSizes.some(
          (s) =>
            !s.normalized.includes("filtersettinggroup") &&
            !s.normalized.startsWith("gid://"),
        );

        if (!hasHumanReadableSize) {
          sizeFilterInputs.forEach((input) => {
            if (!input.checked) return;
            const resolvedLabel = normalizeSize(getSizeInputLabel(input));
            if (!resolvedLabel) return;
            if (selectedSizes.some((s) => s.normalized === resolvedLabel)) return;
            selectedSizes.push({
              value: resolvedLabel,
              label: resolvedLabel,
              normalized: resolvedLabel,
            });
          });
        }
      }

      // Sizes for "+" group
      if (selectedSizes.some((s) => s.normalized === "+")) {
        const plus_sizes = [
          "10",
          "10-40",
          "10/11",
          "10M",
          "10W",
          "9",
          "11",
          "11M",
          "12",
          "12-18m",
          "12-18M",
          "12M",
          "13",
          "13M",
          "6",
          "14",
          "18-24m",
          "18-24M",
          "2/3",
          "24-36m",
          "24-36M",
          "5",
          "25",
          "27",
          "29",
          "3-6m",
          "3-6M",
          "36/XL",
          "7",
          "38",
          "38/XXL",
          "4",
          "4/5",
          "40",
          "42",
          "44",
          "46",
          "48",
          "50",
          "5W",
          "6-12m",
          "6-12M",
          "6/7",
          "6W",
          "7/8",
          "7M",
          "7W",
          "8",
          "8-38",
          "8-41",
          "8/9",
          "8M",
          "8W",
          "9-39",
          "9-42",
          "9M",
          "9W",
          "9W/8M",
        ];

        plus_sizes.forEach((size) => addSizeSelection(size, size));
      }

      if (selectedSizes.length > 0) {
        // || document.body.id == "archive-industry-of-all-nations"
        sizeFilterApplied = true;

        // IF THERE WAS ALSO A COLOR FILTER APPLIED, EVEN WITH NO RESULTS
        if (colorFilterApplied) {
          productArray = filteredProducts;
          filteredProducts = [];
        }

        if (productArray.length > 0) {
          productArray.forEach(function (product) {
            var hasAvailableSize = false;
            var sizeSelectors = product.querySelectorAll(
              'form[action="/cart/add"]',
            );

            sizeSelectors.forEach((selector) => {
              if (!selector.classList.contains("collection-final-card")) {
                var sizeSubmitInput = selector.querySelector('input[type="submit"]');
                var sizeInputValue = sizeSubmitInput ? sizeSubmitInput.value : "";
                var sizeInputNormalized = normalizeSize(sizeInputValue);
                var matchesSelectedSize = selectedSizes.some(
                  (size) => size.normalized === sizeInputNormalized,
                );
                if (
                  selector.classList.contains(
                    "collection-cart-btn__one-variant",
                  )
                ) {
                  if (
                    (selectedSizes.length > 0 && !matchesSelectedSize) ||
                    selector.classList.contains("disabled")
                  ) {
                    selector.remove();
                  } else {
                    hasAvailableSize = true;
                  }
                } else if (
                  (selectedSizes.length > 0 && !matchesSelectedSize) ||
                  selector.classList.contains("disabled")
                ) {
                  selector.remove();
                } else {
                  hasAvailableSize = true;
                }
              }
            });

            if (hasAvailableSize && !filteredProducts.includes(product)) {
              filteredProducts.push(product);
            }
            if (!hasAvailableSize) {
              product.remove();
            }
          });
        }
      }
    }

    // SIZE FILTER
    if (badgeFilterInputs.length > 0) {
      var selectedBadges = [];

      badgeFilterInputs.forEach((input) => {
        if (input.checked) {
          selectedBadges.push(input.getAttribute("value"));
        }
      });

      if (selectedBadges.length > 0) {
        badgeFilterApplied = true;

        // IF THERE WAS ALSO A COLOR OR SIZE FILTER APPLIED, EVEN WITH NO RESULTS
        if (colorFilterApplied || sizeFilterApplied) {
          productArray = filteredProducts;
          filteredProducts = [];
        }

        if (productArray.length > 0) {
          productArray.forEach(function (product) {
            var hasAvailableSize = false;
            var sizeSelectors = product.querySelectorAll(
              'form[action="/cart/add"]',
            );

            selectedBadges.forEach((selBadge) => {
              var productBadgeValue = product.getAttribute("data-badge");

              if (
                productBadgeValue === selBadge &&
                !filteredProducts.includes(product)
              ) {
                sizeSelectors.forEach((selector) => {
                  if (selector.classList.contains("disabled")) {
                    selector.remove();
                  } else {
                    hasAvailableSize = true;
                  }
                });

                if (hasAvailableSize) {
                  filteredProducts.push(product);
                } else {
                  product.remove();
                }
              }
            });
          });
        }
      }
    }

    // END FILTERS

    if (sizeFilterApplied && filteredProducts.length > 0) {
      const moduloItem = document.querySelector(".product_item.modulo_item");
      if (moduloItem && !filteredProducts.includes(moduloItem)) {
        filteredProducts.push(moduloItem);
      }
    }

    if (filteredProducts.length > 0) {
      productContainer.innerHTML = "";
      const renderedProducts = new Set();
      filteredProducts.forEach(function (product) {
        if (!(product instanceof Node) || renderedProducts.has(product)) {
          return;
        }
        renderedProducts.add(product);
        productContainer.appendChild(product);
      });
    } else if (
      filteredProducts.length == 0 &&
      (colorFilterApplied || sizeFilterApplied)
    ) {
      // If the server already filtered results but our client-side match failed (e.g., data-color-filter mismatch),
      // keep the server-rendered products to avoid blank states.
      if (productArray.length > 0) {
        return; // leave DOM as-is
      }
      productContainer.innerHTML =
        '<div class="m-4">No results were found. Please try a different filter.</div>';
    }
  }

  static resetMiniaturesListeners() {
    var sliders = document.querySelectorAll(".slider-clp-images");

    if (sliders.length > 0) {
      sliders.forEach(function (slider) {
        var sliderPagination = slider.querySelector(".swiper-pagination");
        var sliderNextButton = slider.querySelector(".swiper-button-next");
        var sliderPrevButton = slider.querySelector(".swiper-button-prev");

        var CLPslider = new Swiper(slider, {
          loop: true,
          slidesPerView: 1,
          pagination: {
            el: sliderPagination,
            clickable: true,
          },
          navigation: {
            nextEl: sliderNextButton,
            prevEl: sliderPrevButton,
          },
          spaceBetween: 1,
        });

        var slidesLength = CLPslider.slides.length;
        slider.classList.add("slides-number-" + slidesLength);
      });
    }

    var variants = document.querySelectorAll(
      ".collection-cart-btn__variants.available",
    );

    if (variants.length > 0) {
      variants.forEach((variant) => {
        variant.addEventListener("submit", function (event) {
          event.preventDefault();
          event.stopPropagation();

          const variantID = this.querySelector('input[name="id"]').value;
          FacetFiltersForm.addToCart(variantID, 1);
        });
      });
    }
  }

  static addToCart(variantId, quantity) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: quantity,
          },
        ],
      }),
    }).then((response) => {
      if (!response.ok) {
        throw new Error();
      }
      return response.json();
    });
  }

  static slideToSwiperImageInner(index) {
    var imageSwitcherFirst = document.querySelector(
      ".image-switcher-container .first-image-selector",
    );
    var imageSwitcherSecond = document.querySelector(
      ".image-switcher-container .second-image-selector",
    );

    if (imageSwitcherFirst && imageSwitcherSecond) {
      if (index == 0) {
        imageSwitcherFirst.classList.add("picked");
        imageSwitcherSecond.classList.remove("picked");
      } else if (index == 1) {
        imageSwitcherSecond.classList.add("picked");
        imageSwitcherFirst.classList.remove("picked");
      }
    }

    var sliders = document.querySelectorAll(".slider-clp-images");

    if (sliders.length > 0 && (index == 0 || index == 1)) {
      sliders.forEach(function (slider) {
        if (slider.swiper) {
          slider.swiper.slideTo(index);
        }
      });
    }

    var paginationLinks = document.querySelectorAll(".pagination a");

    if (paginationLinks.length > 0 && (index == 0 || index == 1)) {
      paginationLinks.forEach(function (link) {
        var url = new URL(link.href);
        url.searchParams.set("image", index);
        link.href = url.toString();
      });
    }
  }
}

var urlParams = new URLSearchParams(window.location.search);
var sortBy = urlParams.get("sort_by");

if (sortBy) {
  FacetFiltersForm.customSorting(sortBy);
}

FacetFiltersForm.customFiltering();

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define("facet-filters-form", FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll("input").forEach((element) => {
      element.addEventListener("change", this.onRangeChange.bind(this));
      element.addEventListener("keydown", this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern =
      /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll("input");
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute("data-max", maxInput.value);
    if (minInput.value) maxInput.setAttribute("data-min", minInput.value);
    if (minInput.value === "") maxInput.setAttribute("data-min", 0);
    if (maxInput.value === "")
      minInput.setAttribute("data-max", maxInput.getAttribute("data-max"));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute("data-min"));
    const max = Number(input.getAttribute("data-max"));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define("price-range", PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector("a");
    facetLink.setAttribute("role", "button");
    facetLink.addEventListener("click", this.closeFilter.bind(this));
    facetLink.addEventListener("keyup", (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === "SPACE") this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form =
      this.closest("facet-filters-form") ||
      document.querySelector("facet-filters-form");
    form.onActiveFilterClick(event);
  }
}

customElements.define("facet-remove", FacetRemove);

function closeDrawers() {
  var filterDrawer = document.querySelector(
    "menu-drawer > details.menu-opening",
  );
  if (filterDrawer) {
    filterDrawer.querySelector("summary").click();
  }
}

// var drawerBackgrounds = document.querySelectorAll('.facets-background');

// drawerBackgrounds.forEach((element) => {
//   element.addEventListener('click', closeDrawers);
// });

// SORTING IN PANEL
var sortSelectOptions = document.querySelectorAll(".options-group label");

if (sortSelectOptions) {
  sortSelectOptions.forEach((label) => {
    label.addEventListener("click", function () {
      sortSelectOptions.forEach((eachLabel) => {
        eachLabel.classList.remove("selected");
      });

      label.classList.add("selected");
      var sortSelect = document.querySelector("#FacetSortDrawerForm select");
      var sortForm = document.querySelector("#FacetSortDrawerForm");
      var value = label.getAttribute("data-value");

      Array.from(sortSelect.options).forEach((option) => {
        if (option.value === value) {
          sortSelect.value = value;
        }
      });

      sortForm.dispatchEvent(new Event("input"));
    });
  });

  // SELECT FIRST SORTING OPTION TO "REMOVE" SORTING
  var removeSortBtn = document.querySelector(".remove-sorting");

  if (removeSortBtn) {
    removeSortBtn.addEventListener("click", function (e) {
      e.preventDefault();

      var sortSelect = document.querySelector("#FacetSortDrawerForm select");
      var sortForm = document.querySelector("#FacetSortDrawerForm");

      sortSelect.value = sortSelect.options[0].value;

      sortForm.dispatchEvent(new Event("input"));

      document.querySelectorAll(".options-group label").forEach((label) => {
        label.classList.remove("selected");
      });
    });
  }
}

function slideToSwiperImage(index) {
  var sliders = document.querySelectorAll(".slider-clp-images");

  if (sliders.length > 0) {
    sliders.forEach(function (slider) {
      if (slider.swiper) {
        slider.swiper.slideTo(index);
      }
    });
  }
}

var imageSwitcherSecond = document.querySelector(
  ".image-switcher-container .second-image-selector",
);
var imageSwitcherFirst = document.querySelector(
  ".image-switcher-container .first-image-selector",
);
const sortOptionsBtn = document.querySelector("#FacetSortDrawerForm");
const sortCloseBtn = document.querySelector(".sort_close");

function handleImageSwitcherClick(clickedElement, otherElement, slideIndex) {
  const url = new URL(window.location.href);

  if (clickedElement.classList.contains("picked")) {
    clickedElement.classList.remove("picked");
    slideToSwiperImage(0);
    url.searchParams.delete("image");
    togglePaginationLinkImageParams(false);
  } else {
    clickedElement.classList.add("picked");
    otherElement.classList.remove("picked");
    slideToSwiperImage(slideIndex);
    url.searchParams.set("image", slideIndex);
    togglePaginationLinkImageParams(true, slideIndex);
  }

  history.replaceState(null, "", url);

  closeDrawers();
  if (sortOptionsBtn) sortOptionsBtn.classList.remove("open");
}

if (imageSwitcherFirst && imageSwitcherSecond) {
  imageSwitcherFirst.addEventListener("click", () =>
    handleImageSwitcherClick(imageSwitcherFirst, imageSwitcherSecond, 0),
  );
  imageSwitcherSecond.addEventListener("click", () =>
    handleImageSwitcherClick(imageSwitcherSecond, imageSwitcherFirst, 1),
  );
}

const toggleContainer = document.querySelector(
  ".image-switcher-container .toggle",
);

if (toggleContainer) toggleContainer.addEventListener("click", function () {
  imageSwitcherSecond = document.querySelector(
    ".image-switcher-container .second-image-selector",
  );
  imageSwitcherFirst = document.querySelector(
    ".image-switcher-container .first-image-selector",
  );
  if (imageSwitcherSecond.classList.contains("picked")) {
    handleImageSwitcherClick(imageSwitcherFirst, imageSwitcherSecond, 0);
  } else {
    handleImageSwitcherClick(imageSwitcherSecond, imageSwitcherFirst, 1);
  }
});

document.addEventListener("DOMContentLoaded", function () {
  if (!imageSwitcherFirst || !imageSwitcherSecond) return;
  var urlParams = new URLSearchParams(window.location.search);
  var productImagePicker = urlParams.get("image");

  if (productImagePicker) {
    if (productImagePicker == 0) {
      handleImageSwitcherClick(imageSwitcherFirst, imageSwitcherSecond, 0);
    } else if (productImagePicker == 1) {
      handleImageSwitcherClick(imageSwitcherSecond, imageSwitcherFirst, 1);
    }
  }
});

function togglePaginationLinkImageParams(set, value) {
  var paginationLinks = document.querySelectorAll(".pagination a");

  if (paginationLinks.length > 0) {
    paginationLinks.forEach(function (link) {
      var url = new URL(link.href);
      if (!set) {
        url.searchParams.delete("image");
      } else {
        url.searchParams.set("image", value);
      }

      link.href = url.toString();
    });
  }
}

if (sortOptionsBtn) {
  sortOptionsBtn.addEventListener("click", function () {
    sortOptionsBtn.classList.toggle("open");
    closeDrawers();
    // imageSwitcherFirst.classList.remove('picked');
    // imageSwitcherSecond.classList.remove('picked');
  });
}

if (sortCloseBtn && sortOptionsBtn) {
  sortCloseBtn.addEventListener("click", function () {
    sortOptionsBtn.classList.toggle("open");
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
